import {
  displayError,
  displaySuccess,
  displayWarning,
} from "../../utils/messageToast";
import { SetupFlow } from "../../apis/apisFlowByAuthorizationRA";
import { arrayCSV } from "../../utils/functionsInterfaces";

export const createSkillsForce = async (
  ambient: string,
  authorization: string,
  namesData: arrayCSV[],
  setTextAreaValue: React.Dispatch<React.SetStateAction<string>>,
  setIsErrors: React.Dispatch<React.SetStateAction<boolean>>,
  setErrors: React.Dispatch<React.SetStateAction<any[]>>,
  signOut: () => void
) => {
  try {
    const apiClient = SetupFlow(authorization);
    const response = await apiClient.post(
      `/create-skills?ambient=${ambient}&isInForce=true`,
      namesData
    );
    if (response.data.errors.length > 0) {
      displayWarning("Algumas habilidades não foram criadas!");
      setTextAreaValue(JSON.stringify(response.data.skillCreated, null, 2));
      setIsErrors(true);
      setErrors(response.data.errors);

      setTextAreaValue("");
      return;
    } else {
      displaySuccess("Habilidades criadas com sucesso!");
      setTextAreaValue(JSON.stringify(response.data.skillCreated, null, 2));
      setIsErrors(false);
      setErrors([]);

      setTextAreaValue("");
      return;
    }
  } catch (error: any) {
    displayError("Erro ao criar habilidades!");
    return;
  }
};
